import { render, staticRenderFns } from "./AllProviders.vue?vue&type=template&id=1af6b07c&"
import script from "./AllProviders.vue?vue&type=script&lang=js&"
export * from "./AllProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports